import { Helmet } from "react-helmet-async"
import { TripsList } from "../../../../Trips"
import { useParams } from "../../../../router-utils"

export default function TripSourceDetailsPage() {
	const { tripSourceId } = useParams(
		"/trip-sources/:tripSourceId/payments/incoming"
	)
	return (
		<>
			<Helmet>
				<title>Trip Source Trips</title>
			</Helmet>
			<TripsList
				disableAddition
				hideBulkActions
				hideTripSourceFilter
				hideTouristProfileFilter
				tripSourceIds={tripSourceId}
			/>
		</>
	)
}
